import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'status',
  templateUrl: './status.component.html'
})

export class StatusComponent {
  cookies;
  localstorage;
  logged;

  constructor(
    private cookieService: CookieService,
  ) {
    this.cookies = JSON.stringify(cookieService.getAll());
    this.localstorage = JSON.stringify(localStorage);
    this.logged = cookieService.check(environment.COOKIE_AT);
  }

  resetLocalStorage() {
    localStorage.clear();
  }

  resetCookies() {
    this.cookieService.deleteAll('/', environment.COOKIE_DOMAIN);
  }
}
